export function isBase64(str, allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']) {
   if (typeof str !== "string") return false;

   // Verifica si la cadena comienza con "data:{tipo}/"
   return allowedTypes.some(type => str.startsWith(`data:${type.split('/')[0]}/`));
}